<template>
  <header class="header">
    <portal-target name="menu-toggler"></portal-target>

    <portal-target name="page-title"></portal-target>

    <UserWidgetPopover />
  </header>
</template>

<script>
import UserWidgetPopover from './UserWidgetPopover.vue'

export default {
  name: 'Header',
  components: { UserWidgetPopover },
}
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: $headerMobileHeight;
  padding: 0 rem(16px);
  background: $color-gray-25;

  @include createFlex(flexbox, nowrap, row, space-between, center, center);

  @include media_tablet() {
    height: $headerHeight;
    padding: 0 rem(20px);
  }
}
</style>
